import { render, staticRenderFns } from "./StepGrundlag.vue?vue&type=template&id=5b5c3090&scoped=true&"
import script from "./StepGrundlag.vue?vue&type=script&lang=js&"
export * from "./StepGrundlag.vue?vue&type=script&lang=js&"
import style0 from "./StepGrundlag.vue?vue&type=style&index=0&id=5b5c3090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c3090",
  null
  
)

export default component.exports